import React from 'react';
import Table from 'react-bootstrap/Table';

import Icon from '../../../../common/Icon';
import {CreateSchemaContext} from '../context/CreateSchemaContext';

import './FilesList.scss';

/**
 * A component rendering files attributes and actions.
 */
class FilesList extends React.Component {

  static contextType = CreateSchemaContext;

  render() {
    const {files, deleteOntology} = this.context;
    return (
      <Table responsive striped hover className="FilesList">
        <tbody>
        {
          files.map((file: any) =>
            <tr key={file.filename}>
              <td>{file.originalname}</td>
              <td className="actions-column">
                <button onClick={() => deleteOntology(file.path)}
                        className="remove-file-button" title="Delete file">
                  <Icon icon="trash"/>
                </button>
              </td>
            </tr>
          )
        }
        </tbody>
      </Table>
    );
  }
}

export default FilesList;
